/**
 *  this file should be used to declare all the static content or values
 **/

 import { headersType } from '../interfaces/TableComponent'

export const headers: headersType = ['Property ID','Property Name','Country','City']
export const optionsForViewOptions = [
  { value: 1, name: 'Property ID', checked: true, disabled: false },
  { value: 2, name: 'Property Name', checked: true, disabled: false },
  { value: 3, name: 'Country', checked: true, disabled: false },
  { value: 4, name: 'City', checked: true, disabled: false },
];

//RENOVATION TABLE
export const renovationDescriptionsTable = [
  { value: 1, name: 'ID', propertyName: 'renovationid', classContainer: 'col-1', checked: true, disabled: false },
  { value: 2, name: 'Renovation Name', propertyName: 'name', classContainer: 'col-3', checked: true, disabled: false },
  { value: 3, name: 'Renovation Completion Year', propertyName: 'completionyear', classContainer: 'col-3', checked: true, disabled: false },
  { value: 4, name: 'Renovation Description', propertyName: 'description', classContainer: 'col-5', checked: true, disabled: false },
];
// OTHER DESCRIPTION TABLE
export const otherDescriptionTable = [
  { value: 1, name: 'Description ID', propertyName: 'descriptionid', classContainer: 'col-1', checked: true, disabled: false },
  { value: 2, name: 'Name', propertyName: 'descriptiontitle', classContainer: 'col-2', checked: true, disabled: false },
  { value: 3, name: 'Type', propertyName: 'descriptiontype', classContainer: 'col-1', checked: true, disabled: false },
  { value: 4, name: 'Start Date', propertyName: 'startdate', classContainer: 'col-1', checked: true, disabled: false },
  { value: 5, name: 'End Date', propertyName: 'enddate', classContainer: 'col-1', checked: true, disabled: false },
  { value: 6, name: 'Description', propertyName: 'description', classContainer: 'col-3', checked: true, disabled: false },
  { value: 7, name: 'Tags', propertyName: 'tags', classContainer: 'col-3', checked: true, disabled: false, displayTags: true },
]

//CLASSIFICATION LOCATION TABLE
export const classificationLocationTable = [
  { value: 1, name: 'Category Standard', propertyName: 'locationstandard', classContainer: 'col-3', checked: true, disabled: false },
  { value: 2, name: 'Location Category', propertyName: 'locationcategory', classContainer: 'col-3', checked: true, disabled: false },
  { value: 3, name: 'Location Detail', propertyName: 'detail', classContainer: 'col-5', checked: true, disabled: false },
];

//CLASSIFICATION SEGMENT TABLE
export const classificationSegmentTable = [
  { value: 1, name: 'Segment Name', propertyName: 'name', classContainer: 'col-3', checked: true, disabled: false },
  { value: 2, name: 'Segment Category', propertyName: 'segmentcategory', classContainer: 'col-3', checked: true, disabled: false },
  { value: 3, name: 'Segment Detail', propertyName: 'detail', classContainer: 'col-5', checked: true, disabled: false },
];

//CLASSIFICATION PROPERTY TABLE
export const classificationPropertyTable = [
  { value: 1, name: 'Property Name', propertyName: 'name', classContainer: 'col-3', checked: true, disabled: false },
  { value: 2, name: 'Property Category', propertyName: 'propertycategory', classContainer: 'col-3', checked: true, disabled: false },
  { value: 3, name: 'Property Detail', propertyName: 'detail', classContainer: 'col-5', checked: true, disabled: false },
];

// Feature Flags
export const TRUE = 'True'
export const TITLE = 'title'
export const CONTENT_SUITE = 'Content Suite'
export const PROPERTY_SEARCH = 'Property Search'
export const CHAIN = 'Chain'

export enum AVAILABILITY_OPTIONS {
  EMPTY = '',
  AVAILABLE_24_7 = 'Available 24/7',
  LIMITED_AVAILABILITY = 'Limited Availability',
  NOT_AVAILABLE = 'Not Available'
}

export enum SESSION_KEYS {
  SESSION = 'session',
  PROPERTY_PARAMS_SESSION = 'propertyparams',
}


export enum PROXIMITY_OPTIONS {
  ONSITE = "Onsite",
  OFFSITE = "Offsite",
  NEARBY = "Nearby",
  INFORMATION_NOT_AVALABLE = "Information Not Available",
  ONSITE_AND_OFFSITE = "Onsite and Offsite",
}

export const HHmmFormat = 'HH:mm'

export type customAntInputValidation = "" | "error" | "success" | "warning" | "validating" | undefined

export const DEADLINE_TYPES = {
  DAY_OF_ARRIVAL: 'Day of Arrival Time',
  UNIT_TIME: 'Time Unit',
}

export const TIME_UNITS = ['Year', 'Month', 'Week', 'Day', 'Hour', 'Second', 'FullDuration', 'Minute']
